module.exports = __webpack_public_path__ + "static/img/5449_phase_function_Paper_Points.c38129b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5449_phase_function_Paper_Points.png
// module id = bhcw
// module chunks = 0